import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';

import {
  SET_SHOW_PAGE_COLLAPSING_HEADER,
  SET_IS_SUB_MENU_DROPDOWN_CONTENT,
} from './constants';

const initialState = {
  showPageCollapsingHeader: false,
  isSubMenuDropdownContent: false,
};

export const pageCollapsingHeaderReducer = createReducer(initialState, {
  [SET_SHOW_PAGE_COLLAPSING_HEADER]: (state, action) => {
    return {
      ...state,
      showPageCollapsingHeader: action.payload,
    };
  },
  [SET_IS_SUB_MENU_DROPDOWN_CONTENT]: (state, action) => {
    return {
      ...state,
      isSubMenuDropdownContent: action.payload,
    };
  },
});
